export const MiddleDot = '∙';
